// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1NhR8","colMaxWidth":"Table_colMaxWidth__3yphm"};